import React, { useState, useEffect } from "react";

const Skills = () => {
    const [skills, setSkills] = useState([]);

    useEffect(() => {
        fetch("/skills.json")
            .then(res => res.json())
            .then(data => {
                const visibleSkills = data.filter(skill => skill.visible !== false);
                setSkills(visibleSkills);
            })
            .catch(err => console.log("Using default skills"));
    }, []);

    const skillCategories = [
        {
            title: "Gameplay & Systems",
            icon: "⚙️",
            skills: ["Game Loops", "State Machines", "Turn-Based Systems", "Board Logic", "Merge Mechanics", "Physics Systems", "AI & Rule-Based Logic"]
        },
        {
            title: "Platform & Production",
            icon: "🚀",
            skills: ["Android/iOS", "WebGL", "Rapid Prototyping", "Publishing Pipelines", "SDK Integration", "API Integration", "Live Operations"]
        },
        {
            title: "Optimization & Performance",
            icon: "⚡",
            skills: ["Profiling & Memory Management", "GC Allocation Reduction", "Frame-Time Optimization", "UI Batching", "Asset Pipeline", "Addressables"]
        },
        {
            title: "UI & Monetization",
            icon: "💰",
            skills: ["Canvas System", "UI Toolkit", "TextMeshPro", "Google AdMob", "In-App Purchases", "Real-Money Systems", "Analytics Integration"]
        },
        {
            title: "Multiplayer & Networking",
            icon: "🌐",
            skills: ["Turn-Based Multiplayer", "Unity Netcode", "REST APIs", "Session Management", "Player Data Sync", "Error Handling"]
        },
        {
            title: "Tools & Workflow",
            icon: "🛠️",
            skills: ["Git/Plastic SCM", "Unity Editor", "Rider/Visual Studio", "Profiler", "Debugger", "Jira", "Figma"]
        }
    ];

    return (
        <section id="skills" className="py-20 md:py-28 transition-colors duration-300">
            <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
                {/* Header */}
                <div className="mb-16 space-y-3">
                    <h2 className="text-4xl md:text-5xl font-bold">Skills & Expertise</h2>
                    <p className="text-lg max-w-3xl">
                        Core competencies in gameplay systems, performance optimization, and production-grade delivery across mobile and WebGL platforms.
                    </p>
                </div>

                {/* Skills Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {skillCategories.map((category, idx) => (
                        <div
                            key={idx}
                            className="card p-6 md:p-8 space-y-4"
                        >
                            {/* Category Header */}
                            <div className="flex items-start gap-3">
                                <span className="text-3xl">{category.icon}</span>
                                <h3 className="text-lg font-semibold flex-1">{category.title}</h3>
                            </div>

                            {/* Skills List */}
                            <div className="space-y-2">
                                {category.skills.map((skill, skillIdx) => (
                                    <div key={skillIdx} className="flex items-start gap-2">
                                        <span className="text-accent-color mt-1.5" style={{color: 'rgb(var(--accent-color))'}}>•</span>
                                        <span className="text-sm">{skill}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Skills;
